import { ShelfType, Version } from "@smartdevis/server/src/domainCatalog"
import { IdLite } from "@smartdevis/utils/src/id"
import { adminPaths } from "../paths"
import { navigate } from "./authState"

export const navigateToNextCatalog = (catalogId: IdLite, shelfVersion: Version, shelfType: ShelfType) =>
    navigate({ to: adminPaths.catalog, params: { catalogId, shelfVersion: `${shelfVersion + 1}`, shelfType } })
